import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

/**
 * SimpleTooltip - A wrapper component for easy tooltip usage
 * 
 * Usage:
 * <SimpleTooltip content="This is the tooltip text">
 *   <button>Hover me</button>
 * </SimpleTooltip>
 * 
 * Or with an icon:
 * <SimpleTooltip content="Help text" showIcon>
 *   <span>Label</span>
 * </SimpleTooltip>
 */
const SimpleTooltip = ({ 
  children, 
  content, 
  side = 'top',
  delayDuration = 200,
  className = ''
}) => {
  if (!content) return children;
  
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent side={side} className={className}>
          <p>{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SimpleTooltip;
